import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { clientVisitToServerMap } from 'app/businessRules';
import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { storeVisit as storeVisitActions } from '../actions';
import { STORE_VISIT } from '../constants/actionTypes';
import { saveVisit, updateVisit } from '../repository';


function *_storeVisit(action) {
    const {formData} = action;
    yield put(loadDataAction('storeVisit'));

    try {
        let visit, payload;
        if (formData.trac) {
            payload = clientVisitToServerMap(formData, true);
            visit = yield call(updateVisit(payload, payload.trac));
        } else {
            payload = clientVisitToServerMap(formData);
            visit = yield call(saveVisit(payload));
        }
        yield put(storeVisitActions.success(visit));
        yield put(loadDataSuccessAction('storeVisit', 'visit.form.save.success'));
    } catch (error) {
        yield put(storeVisitActions.error(error));
        yield put(loadDataErrorAction('storeVisit', {response: error.response, body: error.body, titleId:'visit.form.save.failed'}, action));
    }

}


export function *storeVisit() {
    yield takeLatest(STORE_VISIT.REQUEST, _storeVisit);
}